import { render, staticRenderFns } from "./oss.vue?vue&type=template&id=e536e9a2&scoped=true"
import script from "./oss.vue?vue&type=script&lang=js"
export * from "./oss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e536e9a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e536e9a2')) {
      api.createRecord('e536e9a2', component.options)
    } else {
      api.reload('e536e9a2', component.options)
    }
    module.hot.accept("./oss.vue?vue&type=template&id=e536e9a2&scoped=true", function () {
      api.rerender('e536e9a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/oss.vue"
export default component.exports